export const COMPANY_STATE_KEY='company';
export const AUTH_DATA_STATE_KEY = 'authorization';
